import React from 'react';
import { Container, useTheme, Text, Button, useBreakpoint } from 'basis';
import { byCard, getProductName } from 'utils/byConfig';
import {
  PRODUCT_CODE_AFS,
  PRODUCT_CODE_AU_GEM,
  PRODUCT_CODE_GO,
  PRODUCT_CODE_LOW_RATE,
  PRODUCT_CODE_TWENTY_EIGHT_DEGREES,
} from '_config';
import { HeaderBannerTextStyle, ProductNameWrapper, ProductSubtitle, ButtonWrapper } from './LandingPageAu.styles';

const HeaderBannerTextArea = ({ openFeatureAndBenefitsModal }) => {
  const theme = useTheme();
  const breakpoint = useBreakpoint();
  const buttonLabel = byCard({
    [PRODUCT_CODE_AFS]: 'View features & benefits',
    default: ['md', 'lg', 'xl'].includes(breakpoint) ? 'View features and benefits' : 'View features',
  });
  const productName = getProductName();
  const featureBenefitBtn = (
    <Button margin="0 0 8 0" variant="secondary" onClick={openFeatureAndBenefitsModal}>
      {buttonLabel}
    </Button>
  );
  return (
    <HeaderBannerTextStyle theme={theme}>
      <Container
        padding="0 4 8 4"
        padding-xs="0 4"
        padding-md="0 0 0 0"
        margin="0"
        margin-md="0 0 0 5"
        margin-lg="0 0 0 5"
        margin-xl="0 0 0 5"
        width="100%"
      >
        <ProductNameWrapper>
          {byCard({
            [PRODUCT_CODE_AU_GEM]: 'Apply for a Latitude Gem Visa credit card',
            [PRODUCT_CODE_GO]: 'Apply for a Latitude GO Mastercard credit card',
            [PRODUCT_CODE_AFS]: 'Apply for a CreditLine credit card',
            [PRODUCT_CODE_TWENTY_EIGHT_DEGREES]: `Apply for a ${productName}`,
            [PRODUCT_CODE_LOW_RATE]: `Apply for a ${productName}`,
            default: '',
          })}
          <br />
        </ProductNameWrapper>
        <ProductSubtitle>
          <Text margin="4 0" margin-xs="3 0 8 0" textStyle-md="subtitle2" textStyle-xs="body1">
            {byCard({
              [PRODUCT_CODE_AU_GEM]: 'Shop today with more time to pay.',
              [PRODUCT_CODE_GO]: 'Break up your bigger buys at hundreds of\nAustralia’s biggest retailers.',
              default: '',
            })}
          </Text>
        </ProductSubtitle>
        <ButtonWrapper>
          {byCard({
            [PRODUCT_CODE_AU_GEM]: featureBenefitBtn,
            default: (
              <Button margin="0 0 8 0" variant="secondary" onClick={openFeatureAndBenefitsModal}>
                {buttonLabel}
              </Button>
            ),
          })}
        </ButtonWrapper>
      </Container>
    </HeaderBannerTextStyle>
  );
};

export { HeaderBannerTextArea };
